import { keyframes } from "goober";

// The Web Animations API can't read CSS custom properties, so these mirror the motion tokens in variables.css.
export const MOTION_FAST_MS = 120;
export const MOTION_BASE_MS = 200;
export const MOTION_SLOW_MS = 320;
export const EASE_OUT = "cubic-bezier(0.2, 0.8, 0.2, 1)";
export const EASE_IN = "cubic-bezier(0.5, 0, 0.9, 0.4)";

export const spin = keyframes`
  from { rotate: 0deg; }
  to { rotate: 360deg; }
`;

export const cursorBlink = keyframes`
  0%, 30% { opacity: 1; }
  50%, 80% { opacity: 0; }
  100% { opacity: 1; }
`;

export const eyeBlink = keyframes`
  0%, 90%, 100% { transform: scaleY(1); }
  95% { transform: scaleY(0.05); }
`;

export const pulseRing = keyframes`
  0% { opacity: 0.8; scale: 0.5; }
  66%, 100% { opacity: 0; scale: 1; }
`;

export const shimmer = keyframes`
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
`;
